<template>
  <div class="navbar__bottom section__content">
    <div class="navbar__bottom-top">
      <div class="navbar__bottom-buttons">
        <LangRouterLink :to="{ name: ROUTES.WARDROBE }" class="button --secondary --nav">
          {{ $t('avatar.edit') }}
        </LangRouterLink>
        <Share />
      </div>
      <div class="navbar__progress">
        <p>{{ progress }}</p>
        <Image :source="$beet.options.hunt.diamond" class="navbar__progress-image" />
      </div>
      <RawHtml :html="$beet.options.hunt.nav.instructions" class="navbar__instructions" />
      <AvatarFull nav />
    </div>
    <div class="navbar__bottom-footer">
      <a
        :href="$beet.options.hunt.site.link"
        target="_blank"
        :title="$beet.options.hunt.site.name"
        class="navbar__bottom-logo"
      >
        <Image :source="$beet.options.hunt.site.logos[$i18n.locale]" />
      </a>
      <p>{{ $beet.options.hunt.site.description }}</p>
      <div class="navbar__bottom-links">
        <RouterLink
          :to="link.link"
          v-for="link in $beet.options.hunt.nav.links"
          :key="link.flexKey"
        >
          {{ link.label }}
        </RouterLink>
      </div>
      <LangRouterLink :to="{ name: ROUTES.AUTH.LOGOUT }" class="button">{{
        $beet.options.hunt.labels.auth.logout
      }}</LangRouterLink>
      <TermsBlock />
      <BeetCredits />
    </div>
  </div>
</template>

<script>
import { AvatarFull } from '@/components/avatar'
import { TermsBlock } from '@/components/blocks'
import { Image, LangRouterLink, RawHtml } from '@/components/global'
import { BeetCredits, Share } from '@/components/small'
import { UsesRoutesMixin } from '@/mixins'

export default {
  name: 'SiteNavBottom',
  mixins: [UsesRoutesMixin],
  components: { AvatarFull, BeetCredits, Image, LangRouterLink, RawHtml, Share, TermsBlock },
  computed: {
    progress() {
      return this.$t('progress')
        .replace(':count', this.$store.state.hunter.completed_riddles_count)
        .replace(':total', this.$store.state.riddle.count)
    },
  },
}
</script>
